//
//
//
//
//
//
//
//
//
//
//

import process from './components/process';
export default {
  name: 'Process',
  components: {
    process: process
  }
};